var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("validation-provider", {
    ref: "provider",
    attrs: {
      name: _vm.validatorProps.name || _vm.label,
      rules: _vm.validatorProps.rules || _vm.rules,
      vid: _vm.validatorProps.vid || _vm.name,
      bails: _vm.validatorProps.bails,
      debounce: _vm.validatorProps.debounce,
      immediate: _vm.validatorProps.immediate,
      mode: _vm.validatorProps.mode,
      persist: _vm.validatorProps.persist,
      tag: "div"
    },
    scopedSlots: _vm._u(
      [
        {
          key: "default",
          fn: function(ref) {
            var errors = ref.errors
            var valid = ref.valid
            return [
              _c(
                "field-wrapper",
                {
                  attrs: {
                    "for-id": _vm.id,
                    label: _vm.label,
                    "hide-label": _vm.$attrs["hide-label"],
                    spacing: _vm.$attrs["spacing"],
                    error: errors
                  }
                },
                [
                  _c(
                    "base-textarea",
                    _vm._b(
                      {
                        attrs: {
                          id: _vm.id,
                          value: _vm.innerValue,
                          invalid: errors && errors.length > 0
                        },
                        on: {
                          "update:value": function($event) {
                            _vm.innerValue = $event
                          }
                        },
                        model: {
                          value: _vm.innerValue,
                          callback: function($$v) {
                            _vm.innerValue = $$v
                          },
                          expression: "innerValue"
                        }
                      },
                      "base-textarea",
                      _vm.$attrs,
                      false
                    )
                  ),
                  _vm.$slots.labelTooltip
                    ? _c(
                        "template",
                        { slot: "labelTooltip" },
                        [_vm._t("labelTooltip")],
                        2
                      )
                    : _vm._e()
                ],
                2
              )
            ]
          }
        }
      ],
      true
    )
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }